// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__NNJLH","ContainerGrid2Colunas":"estilo_ContainerGrid2Colunas__az4W7","Item_Pesquisa":"estilo_Item_Pesquisa__i0Eij"};